<script>
  import axios from 'axios'
  import {nextTick} from "vue";

  const AXCONNECT_URL = "https://axconn.achademix.info";

  export default {
    name: 'LandingPage',
    beforeMount() {
      window.addEventListener('message', function (event) {
        if (this.origin === event.origin) return;
        if (event.data !== 'redirect') return;
        window.location.href = document.getElementById("ifrAhuiliztli").src;
      });
    },
    async mounted() {
      document.title = 'Achademix'
      if(this.$refs.searchInput) this.$refs.searchInput.focus();
      await this.getSchoolInfo(this.$isDev);
    },
    data() {
      return {
        selectedSchool: null,
        username: null,
        password: null,
        schoolUrl: null,
        singleSignOn: [],
        singleSignOnLoading: false,
        singleSignOnBusy: null,
        singleSignOnError: null,
        schoolList: [],
        searchString: ""
      };
    },
    methods: {
      selectSchool(s) {
        this.searchString = null;
        this["selectedSchool"] =  s;
        if (s) nextTick(() => this.$refs.usernameInput.focus());
      },
      selectNext() {
        let refs = Object.keys(this.$refs).filter(s => s.startsWith("_")).filter(s => this.$refs[s] && this.$refs[s].length > 0).sort()
        let nextRef = refs.find(s => s !== undefined);
        if (refs.length > 1) {
          if (nextRef) this.$refs[nextRef][0].focus();
        }else {
          let found = this.schoolList.find(s => `_${s.schoolKey}` === nextRef);
          this.selectSchool(found);
        }
      },
      doLogin() {
        // TODO: Recomiendo aqui validar los inputs y si todo esta bien bloquearlos y continuar. Es decir, hacer las validaciones de input aqui.
        const iframe = document.getElementById("ifrAhuiliztli");
        const params = {
          action: 'redirect-login',
          username: this.username,
          password: this.password
        };
        iframe.contentWindow.postMessage(params, "*");
      },
      async startSingleSignOn(provider) {
        if (!this.selectedSchool?.schoolKey) return;

        this.singleSignOnBusy = provider;
        this.singleSignOnError = null;

        try {
          const csrf = typeof crypto !== "undefined" && crypto.randomUUID
              ? crypto.randomUUID()
              : `${Date.now()}${Math.random()}`.replace(/\D/g, "");
          const response = await axios.get(
              `${AXCONNECT_URL}/schools/${encodeURIComponent(this.selectedSchool.schoolKey)}/single-sign-on/${provider}/start?csrf=${encodeURIComponent(csrf)}`);
          const link = response.data;
          if (typeof link !== "string" || link.length <= 0) {
            this.singleSignOnError = "Single sign-on is unavailable. Please use username and password.";
            return;
          }

          window.location.replace(link);
        } catch {
          this.singleSignOnError = "Single sign-on is unavailable. Please use username and password.";
        } finally {
          this.singleSignOnBusy = null;
        }
      },
      async loadSingleSignOnAvailability(school) {
        const selectedKey = school?.schoolKey;
        this.singleSignOn = [];
        this.singleSignOnError = null;
        this.singleSignOnLoading = !!school;

        if (!selectedKey) {
          this.singleSignOnLoading = false;
          return;
        }

        try {
          const response = await axios.get(`${AXCONNECT_URL}/schools/${encodeURIComponent(selectedKey)}/single-sign-on`, {
            timeout: 10000
          });

          if (this.selectedSchool?.schoolKey !== selectedKey) return;

          const values = Array.isArray(response.data?.singleSignOn)
              ? response.data.singleSignOn.map(s => `${s}`.toLowerCase())
              : [];

          this.singleSignOn = values;
        } catch (error) {
          if (this.selectedSchool?.schoolKey === selectedKey) {
            this.singleSignOn = [];
            console.warn("Unable to load single sign-on availability.", error);
          }
        } finally {
          if (this.selectedSchool?.schoolKey === selectedKey) {
            this.singleSignOnLoading = false;
          }
        }
      },
      getSchoolInfo(all) {
        axios.get(`${AXCONNECT_URL}/schools${all ? '?showAll=true': ''}`)
        .then((response) => this.schoolList = response.data)
        .then(() => {
          if (this.$isLocalhost)
            this.schoolList.push({
              instructorPortal: "http://localhost:8081",
              schoolFullName: "Localhost",
              schoolKey: "localhost",
              schoolName: "Localhost",
              aliases: []
            })
        })
        .catch(() => this.schoolList = JSON.parse("[{\"schoolKey\":\"DEV\",\"schoolName\":\"DEV Test\",\"instructorPortal\":\"https://dev.achademix.net\",\"studentPortal\":\"https://dev.axstudent.com\"}]"));
      }
    },
    watch: {
      selectedSchool() {
        this.schoolUrl = this.selectedSchool ? this.selectedSchool.instructorPortal : "";
        this.loadSingleSignOnAvailability(this.selectedSchool);
      }
    },
    computed: {
      foundList() {
        if (!this.searchString && !this.selectedSchool) return [];
        if (this.selectedSchool) return this.schoolList.filter(s => s === this.selectedSchool);
        let search = this.searchString.toLowerCase();
        return this.schoolList.filter(s =>
          s.schoolKey.toLowerCase().includes(search) || //SchoolKey
          s.schoolName.toLowerCase().includes(search) || //ShortName
          s.schoolFullName.toLowerCase().includes(search) || //FullName
          s.aliases.find(a => a.toLowerCase().includes(search))
        ).slice(0,3);
      },
      showGoogleSSO() {
        return this.singleSignOn.includes("google");
      },
      showMicrosoftSSO() {
        return this.singleSignOn.includes("microsoft");
      }
    }
  };
</script>

<template>
  <div class="shadow-lg p-3 mb-5 bg-body rounded mx-auto mt-5" style="max-width: 400px; margin-top: 150px">
    <div class="d-flex flex-column">
      <div class="form-floating mb-3" v-if="!selectedSchool">
        <input ref="searchInput" name="searchInput" type="text" class="form-control" id="searchFloatingInput" placeholder="" v-model="searchString" @keyup.enter="selectNext()">
        <label for="searchFloatingInput">Search your School</label>
      </div>
      <div v-for="(found) in foundList" :key="found.schoolKey" :ref="`_${found.schoolKey}`" tabindex="0" class="d-flex flex-row m-1 mx-2 px-2 align-items-center" style="transition: width 2s;" @click="selectSchool(found)" @keyup.enter="selectSchool(found)">
        <div>
          <img :src="`/schools/${found.schoolKey}.ico`" onerror="this.src='/schools/default.ico'"  width="60px"  alt="logo"/>
        </div>
        <div class="my-auto ms-2 text-start">
            {{found.schoolFullName}}
        </div>
        <button v-if="selectedSchool" type="button" class="btn-close btn-close-custom ms-auto me-1 pe-1" aria-label="Close" @click.stop="selectSchool()"></button>
      </div>
      <div>
        <div class="form-floating mb-3 mt-3" v-if="selectedSchool">
          <input ref="usernameInput" type="text" class="form-control" id="userFloatingInput" placeholder="" v-model="username" @keyup.enter="this.$refs.passwordInput.focus()">
          <label for="userFloatingInput">Username</label>
        </div>
        <div class="form-floating mb-3" v-if="selectedSchool">
          <input ref="passwordInput" type="password" class="form-control" id="passFloatingInput" placeholder="" v-model="password" @keyup.enter="this.$refs.loginButton.focus()">
          <label for="passFloatingInput">Password</label>
        </div>
      </div>
    </div>
    <div class="row mt-1" v-if="selectedSchool">
      <div class="col">
        <input ref="loginButton" class="btn btn-outline-primary" name="login" type="button" @click="doLogin" value="Login"/>
      </div>
    </div>
    <div v-if="selectedSchool" class="mt-3">
      <div v-if="singleSignOnLoading" class="text-muted small">
        Checking single sign-on...
      </div>
      <button v-if="showGoogleSSO"
              class="gsi-material-button mt-2 w-100"
              :disabled="!!singleSignOnBusy"
              :aria-busy="singleSignOnBusy === 'google'"
              @click="startSingleSignOn('google')">
        <div class="gsi-material-button-state"></div>
        <div class="gsi-material-button-content-wrapper">
          <div class="gsi-material-button-icon">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
              <path fill="none" d="M0 0h48v48H0z"></path>
            </svg>
          </div>
          <span class="gsi-material-button-contents">Sign in with Google</span>
          <span style="display: none;">Sign in with Google</span>
        </div>
      </button>
      <button v-if="showMicrosoftSSO"
              class="gsi-material-button mt-2 w-100"
              :disabled="!!singleSignOnBusy"
              :aria-busy="singleSignOnBusy === 'microsoft'"
              @click="startSingleSignOn('microsoft')">
        <div class="gsi-material-button-state"></div>
        <div class="gsi-material-button-content-wrapper">
          <div class="gsi-material-button-icon">
            <svg width="18px" height="18px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" style="height: 20px; width: 20px; display: block;">
              <rect fill="#F54F0D" x="0" y="0" width="8" height="8"></rect>
              <rect fill="#00A2F2" x="0" y="9" width="8" height="9"></rect>
              <rect fill="#7DBC00" x="9" y="0" width="9" height="8"></rect>
              <rect fill="#FFBA00" x="9" y="9" width="9" height="9"></rect>
            </svg>
          </div>
          <span class="gsi-material-button-contents">Sign in with Microsoft</span>
          <span style="display: none;">Sign in with Microsoft</span>
        </div>
      </button>
      <div v-if="singleSignOnError" class="text-danger small mt-2">
        {{ singleSignOnError }}
      </div>
    </div>
    <iframe id="ifrAhuiliztli" ref="ifrAhuiliztli" style="display: none;" :src="schoolUrl" v-if="selectedSchool"/>
  </div>
</template>

<style lang="css">

.btn-close-custom {
  filter: invert(0.5) sepia(500) saturate(50) hue-rotate(-20deg);
  vertical-align: middle;
}
.verticalAlign {
  vertical-align: middle;
}

.gsi-material-button {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border: 1px solid #747775;
  border-radius: 4px;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: pointer;
  font-family: Roboto, arial, sans-serif;
  font-size: 14px;
  height: 40px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-align: center;
  transition: background-color .218s, border-color .218s, box-shadow .218s;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  max-width: 400px;
  min-width: min-content;
}

.gsi-material-button .gsi-material-button-icon {
  height: 20px;
  margin-right: 12px;
  min-width: 20px;
  width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.gsi-material-button .gsi-material-button-contents {
  flex-grow: 1;
  font-family: Roboto, arial, sans-serif;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}

.gsi-material-button .gsi-material-button-state {
  transition: opacity .218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.gsi-material-button:disabled {
  cursor: default;
  background-color: #ffffff61;
  border-color: #1f1f1f1f;
}

.gsi-material-button:disabled .gsi-material-button-contents,
.gsi-material-button:disabled .gsi-material-button-icon {
  opacity: 38%;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state,
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
  background-color: #303030;
  opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
  background-color: #303030;
  opacity: 8%;
}

</style>
